import { CustomFlowbiteTheme } from "flowbite-react";


const CustomThemeModal: CustomFlowbiteTheme["modal"] =
{
    "root": {
        "base": "z-[100000]",
        "show": {
            "on": "flex bg-gray-800 bg-opacity-50 dark:bg-opacity-80"
        }
    }
};

export default CustomThemeModal;